module.exports = __webpack_public_path__ + "img/operation.d0b543f1.png";